import { Component, OnInit, Input } from '@angular/core';
import { ProcessesService } from '../services/processes.service';
import { Process } from '../models/process';
import { Observable } from 'rxjs';
import { Router } from "@angular/router";


@Component({
  selector: 'app-fetch-processes',
  templateUrl: './fetch-processes.component.html',
  styleUrls: ['./fetch-processes.component.css']
})
export class FetchProcessesComponent{
  processes$: Observable<Process[]>;
  processes: Process[];
  size: number;
  pageSize: number;
  itemsPerPage = 10;
  page = 1;
  @Input()
  showTable = true;
  editableProcess = null;

  constructor(private _processesService: ProcessesService, private router: Router) { 
    this.getProcesses();
  }

  getProcesses() {
    this._processesService.getProcesses().subscribe(
      data => {
        this.processes = data;
        this.size = data.length;
      }
    )
  }

  createProcess(){
    this.router.navigate(['/processes/new']);
  }

  editProcess(process){
    this.showTable = false;
    this.editableProcess = process;
  }

}
